import mixpanel from "mixpanel-browser";
import { isQaAccountSessionActive } from "../../qa-accounts/qa-account-email";

export function blockMixpanelForQaAccount(): void {
  if (!isQaAccountSessionActive()) return;

  const canStopRecording = typeof mixpanel.stop_session_recording === "function";
  if (canStopRecording) {
    mixpanel.stop_session_recording();
  }

  mixpanel.opt_out_tracking();
}
